import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.support.application.item');
import { OnInit, OnChanges, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const wiz: any;

@Component({
    selector: 'wiz-portal-lpsysadmin-support-application-item',
template: templateSource || '',
    styles: [``],
})
export class PortalLpsysadminSupportApplicationItemComponent implements OnInit, OnChanges {
    @Input() application_id: string = '';
    @Input() menu: string = 'overview';

    constructor(@Inject( Service) public service: Service) { }

    public loaded: boolean = false;
    public application: any = null;
    public company: any = null;
    public announcement: any = null;
    public program: any = null;
    public formAnswers: any[] = [];
    public formAnswerGroups: any[] = [];
    public applicationHistory: any[] = [];
    public grade: any = null;
    public investments: any[] = [];
    public fundOptions: any[] = [];
    public submissions: any[] = [];
    public feedbacks: any[] = [];
    public performances: any[] = [];
    public editingSubmission: any = null;
    public editingFeedback: any = null;
    public editingPerformance: any = null;

    public statusKeys = ['submitted','screening','doc_passed','doc_failed','pt_passed','pt_failed','selected','rejected','withdrawn'];
    public submissionTypes = ['homework','report','ir_deck','plan','etc'];
    public submissionStatuses = ['draft','submitted','reviewed','returned'];
    public feedbackTypes = ['general','session','submission'];
    public performanceStatuses = ['draft','submitted','confirmed'];

    public tabs = [
        { key: 'overview', label: '개요' },
        { key: 'history', label: '참여 이력' },
        { key: 'answers', label: '신청서 답변' },
        { key: 'company', label: '기업 프로필' },
        { key: 'investment', label: '투자 정보' },
        { key: 'submission', label: '제출물' },
        { key: 'feedback', label: '피드백' },
        { key: 'performance', label: '성과' },
    ];

    public statusMap: any = {
        submitted: { label: '접수', cls: 'bg-blue-50 text-blue-700' },
        screening: { label: '심사중', cls: 'bg-amber-50 text-amber-700' },
        doc_passed: { label: '서류통과', cls: 'bg-emerald-50 text-emerald-700' },
        doc_failed: { label: '서류탈락', cls: 'bg-red-50 text-red-700' },
        pt_passed: { label: '발표통과', cls: 'bg-emerald-100 text-emerald-800' },
        pt_failed: { label: '발표탈락', cls: 'bg-red-100 text-red-800' },
        selected: { label: '최종선정', cls: 'bg-emerald-600 text-white' },
        rejected: { label: '최종탈락', cls: 'bg-zinc-500 text-white' },
        withdrawn: { label: '철회', cls: 'bg-zinc-100 text-zinc-500' },
    };

    public async ngOnInit() {
        await this.service.init();
        await this.reload();
    }
    public async ngOnChanges() {
        if (this.application_id) await this.reload();
    }

    public async reload() {
        if (!this.application_id) return;
        this.loaded = false;
        await this.service.render();
        const r = await wiz.call('get', { application_id: this.application_id });
        if (r.code != 200) {
            this.service.alert.show({ title: '오류', message: r.data?.message || '데이터를 불러올 수 없습니다.', action: '확인' });
            return;
        }
        const bundle = r.data.data || {};
        this.application = bundle.application;
        this.company = bundle.company;
        this.announcement = bundle.announcement;
        this.program = bundle.program;
        this.grade = bundle.grade;
        this.investments = (bundle.investments || []).map((inv: any) => this.normalizeInvestment(inv));
        this.fundOptions = bundle.funds || [];
        this.applicationHistory = bundle.application_history || (this.application ? [this.application] : []);
        this.submissions = bundle.submissions || [];
        this._buildFormAnswers();
        this.loaded = true;
        await this.service.render();
        await this.loadTab();
    }

    public async loadTab() {
        if (this.menu === 'history') {
            const r = await wiz.call('list_company_applications', { application_id: this.application_id });
            if (r.code == 200) {
                this.applicationHistory = r.data.rows || [];
                this._buildFormAnswers();
            }
        } else if (this.menu === 'submission') {
            const r = await wiz.call('list_company_submissions', { application_id: this.application_id });
            if (r.code == 200) this.submissions = r.data.rows || [];
        } else if (this.menu === 'feedback') {
            const r = await wiz.call('list_feedbacks', { application_id: this.application_id });
            if (r.code == 200) this.feedbacks = r.data.rows || [];
        } else if (this.menu === 'performance') {
            const r = await wiz.call('list_performances', { application_id: this.application_id });
            if (r.code == 200) this.performances = r.data.rows || [];
        }
        await this.service.render();
    }

    public async setTab(k: string) {
        this.menu = k;
        this.editingSubmission = null;
        this.editingFeedback = null;
        this.editingPerformance = null;
        await this.loadTab();
    }

    public statusInfo(s: string) { return this.statusMap[s] || { label: s, cls: 'bg-zinc-100 text-zinc-600' }; }
    public formatMoney(n: any): string { return (Number(n) || 0).toLocaleString(); }

    public downloadUrl(a: any, sourceApplication: any = null): string {
        if (!a) return '#';
        const aid = sourceApplication?.id || this.application?.id || '';
        // 새 모집공고 첨부 (path 포함)
        if (a.path) {
            const params = new URLSearchParams({
                application_id: aid,
                path: a.path,
            });
            return `/wiz/api/portal.lpsysadmin.support.application.item/download?${params.toString()}`;
        }
        // 기존 직접등록 첨부 (stored_name)
        if (a.stored_name) {
            const params = new URLSearchParams({
                application_id: aid,
                stored_name: a.stored_name,
                original_name: a.original_name || a.stored_name,
            });
            return `/wiz/api/portal.lpsysadmin.support.program.item/download_application_file?${params.toString()}`;
        }
        return '#';
    }

    public attName(a: any): string { return a.original_name || a.name || a.stored_name || a.path || '파일'; }
    public attBadge(a: any): string { return a.field_label || a.field_id || a.key || ''; }

    public dateText(v: any): string {
        if (!v) return '-';
        return String(v).slice(0, 10);
    }

    public historyTitle(item: any): string {
        const programTitle = item?.program_title || item?.program?.title || item?.program_id || '지원사업 미지정';
        const announcementTitle = item?.announcement_title || item?.announcement?.title || '';
        return announcementTitle ? `${programTitle} / ${announcementTitle}` : programTitle;
    }

    public applicationOptions(): any[] {
        return this.applicationHistory?.length ? this.applicationHistory : (this.application ? [this.application] : []);
    }

    public selectedApplication(applicationId: string): any {
        return this.applicationOptions().find((x: any) => x.id === applicationId) || this.application;
    }

    public async saveApplication(app: any = null) {
        const target = app || this.application;
        if (!target?.id) return;
        const payload = {
            company_name: target.company_name || '',
            registed_number: target.registed_number || '',
            ceo_name: target.ceo_name || '',
            ceo_email: target.ceo_email || '',
            ceo_phone: target.ceo_phone || '',
            business_area: target.business_area || '',
            employee_count: Number(target.employee_count) || 0,
            revenue: Number(target.revenue) || 0,
            requested_amount: Number(target.requested_amount) || 0,
            summary: target.summary || '',
            status: target.status || 'submitted',
            score_doc: Number(target.score_doc) || 0,
            score_pt: Number(target.score_pt) || 0,
            score_total: Number(target.score_total) || 0,
            rank: Number(target.rank) || 0,
            note: target.note || '',
            submitted_at: target.submitted_at || ''
        };
        const r = await wiz.call('update_application', { application_id: target.id, data: JSON.stringify(payload) });
        if (r.code !== 200) return this.service.alert.show({ title: '저장 실패', message: r.data?.message || '신청 정보를 저장하지 못했습니다.', action: '확인' });
        await this.reload();
    }

    public newInvestment() {
        if (this.investments.some((x: any) => x._is_new)) return;
        const firstFund = this.fundOptions[0] || {};
        this.investments = [{
            _is_new: true,
            id: '',
            fund_id: firstFund.id || '',
            fund_name: firstFund.name || '',
            company_name: this.company?.company_name || this.application?.company_name || '',
            registed_number: this.company?.registed_number || this.application?.registed_number || '',
            investment_date: '',
            investment_type: '',
            investment_stage: '',
            investment_amount: 0,
            invested_shares: 0,
            price_per_share: 0,
            investment_valuation: 0,
            share_ratio: 0,
            memo: ''
        }, ...this.investments];
        this.service.render();
    }

    public cancelInvestment(inv: any) {
        if (!inv?._is_new) return;
        this.investments = this.investments.filter((x: any) => x !== inv);
        this.service.render();
    }

    public async saveInvestment(inv: any) {
        if (!inv) return;
        if (!inv.fund_id) {
            return this.service.alert.show({ title: '저장 실패', message: '조합을 선택하세요.', action: '확인' });
        }
        const payload = {
            status: inv.status || '',
            fund_id: inv.fund_id || '',
            registed_number: inv.registed_number || this.company?.registed_number || this.application?.registed_number || '',
            company_name: inv.company_name || this.company?.company_name || this.application?.company_name || '',
            founded_date: inv.founded_date || '',
            investment_date: inv.investment_date || inv.invest_date || '',
            investment_amount: Number(inv.investment_amount ?? this.investmentAmount(inv)) || 0,
            invested_shares: Number(inv.invested_shares) || 0,
            price_per_share: Number(inv.price_per_share) || 0,
            investment_valuation: Number(inv.investment_valuation) || 0,
            investment_type: inv.investment_type || inv.invest_type || '',
            investment_stage: inv.investment_stage || '',
            share_ratio: Number(inv.share_ratio) || 0,
            memo: inv.memo || ''
        };
        const r = await wiz.call('save_investment', { investment_id: inv.id || '', data: JSON.stringify(payload) });
        if (r.code !== 200) return this.service.alert.show({ title: '저장 실패', message: r.data?.message || '투자 정보를 저장하지 못했습니다.', action: '확인' });
        await this.reload();
    }

    public async deleteInvestment(inv: any) {
        if (inv?._is_new) return this.cancelInvestment(inv);
        if (!inv?.id || !confirm('투자 내역을 삭제하시겠습니까?')) return;
        const r = await wiz.call('delete_investment', { investment_id: inv.id });
        if (r.code !== 200) return this.service.alert.show({ title: '삭제 실패', message: r.data?.message || '투자 정보를 삭제하지 못했습니다.', action: '확인' });
        await this.reload();
    }

    public newSubmission() {
        const app = this.applicationOptions()[0] || this.application;
        this.editingSubmission = {
            application_id: app?.id || this.application_id,
            program_id: app?.program_id || '',
            title: '',
            submission_type: 'homework',
            status: 'draft',
            content: '',
            file_path: ''
        };
        this.service.render();
    }

    public editSubmission(item: any) {
        this.editingSubmission = JSON.parse(JSON.stringify(item || {}));
        this.service.render();
    }

    public cancelSubmission() {
        this.editingSubmission = null;
        this.service.render();
    }

    public async saveSubmission() {
        if (!this.editingSubmission) return;
        const app = this.selectedApplication(this.editingSubmission.application_id);
        this.editingSubmission.program_id = app?.program_id || this.editingSubmission.program_id || '';
        this.editingSubmission.company_id = app?.company_id || this.company?.id || '';
        const payload = {
            id: this.editingSubmission.id || '',
            application_id: this.editingSubmission.application_id || app?.id || this.application_id,
            program_id: this.editingSubmission.program_id || '',
            company_id: this.editingSubmission.company_id || '',
            title: this.editingSubmission.title || '',
            submission_type: this.editingSubmission.submission_type || 'homework',
            status: this.editingSubmission.status || 'draft',
            content: this.editingSubmission.content || '',
            file_path: this.editingSubmission.file_path || ''
        };
        const r = await wiz.call('save_submission', { data: JSON.stringify(payload) });
        if (r.code !== 200) return this.service.alert.show({ title: '저장 실패', message: r.data?.message || '제출물을 저장하지 못했습니다.', action: '확인' });
        this.editingSubmission = null;
        await this.loadTab();
    }

    public async deleteSubmission(item: any) {
        if (!item?.id || !confirm('제출물을 삭제하시겠습니까?')) return;
        const r = await wiz.call('delete_submission', { submission_id: item.id });
        if (r.code !== 200) return this.service.alert.show({ title: '삭제 실패', message: r.data?.message || '제출물을 삭제하지 못했습니다.', action: '확인' });
        await this.loadTab();
    }

    public newFeedback() {
        this.editingFeedback = {
            application_id: this.application_id,
            program_id: this.application?.program_id || '',
            company_id: this.company?.id || this.application?.company_id || '',
            feedback_type: 'general',
            title: '',
            score: null,
            content: '',
            is_visible_to_company: true
        };
        this.service.render();
    }

    public editFeedback(item: any) {
        this.editingFeedback = JSON.parse(JSON.stringify(item || {}));
        this.service.render();
    }

    public cancelFeedback() {
        this.editingFeedback = null;
        this.service.render();
    }

    public async saveFeedback() {
        if (!this.editingFeedback) return;
        const app = this.selectedApplication(this.editingFeedback.application_id);
        this.editingFeedback.program_id = app?.program_id || this.editingFeedback.program_id || '';
        this.editingFeedback.company_id = app?.company_id || this.company?.id || '';
        this.editingFeedback.score = this.editingFeedback.score === '' ? null : this.editingFeedback.score;
        const payload = {
            id: this.editingFeedback.id || '',
            application_id: this.editingFeedback.application_id || app?.id || this.application_id,
            program_id: this.editingFeedback.program_id || '',
            company_id: this.editingFeedback.company_id || '',
            feedback_type: this.editingFeedback.feedback_type || 'general',
            title: this.editingFeedback.title || '',
            score: this.editingFeedback.score,
            content: this.editingFeedback.content || '',
            is_visible_to_company: !!this.editingFeedback.is_visible_to_company
        };
        const r = await wiz.call('save_feedback', { data: JSON.stringify(payload) });
        if (r.code !== 200) return this.service.alert.show({ title: '저장 실패', message: r.data?.message || '피드백을 저장하지 못했습니다.', action: '확인' });
        this.editingFeedback = null;
        await this.loadTab();
    }

    public async deleteFeedback(item: any) {
        if (!item?.id || !confirm('피드백을 삭제하시겠습니까?')) return;
        const r = await wiz.call('delete_feedback', { feedback_id: item.id });
        if (r.code !== 200) return this.service.alert.show({ title: '삭제 실패', message: r.data?.message || '피드백을 삭제하지 못했습니다.', action: '확인' });
        await this.loadTab();
    }

    public newPerformance() {
        const app = this.applicationOptions()[0] || this.application;
        this.editingPerformance = {
            application_id: app?.id || this.application_id,
            program_id: app?.program_id || '',
            company_id: app?.company_id || this.company?.id || '',
            report_period: '',
            revenue: 0,
            investment_raised: 0,
            new_hires: 0,
            new_patents: 0,
            awards: '',
            narrative: '',
            status: 'draft'
        };
        this.service.render();
    }

    public editPerformance(item: any) {
        this.editingPerformance = JSON.parse(JSON.stringify(item || {}));
        this.service.render();
    }

    public cancelPerformance() {
        this.editingPerformance = null;
        this.service.render();
    }

    public async savePerformance() {
        if (!this.editingPerformance) return;
        const app = this.selectedApplication(this.editingPerformance.application_id);
        this.editingPerformance.program_id = app?.program_id || this.editingPerformance.program_id || '';
        this.editingPerformance.company_id = app?.company_id || this.company?.id || '';
        for (const k of ['revenue','investment_raised','new_hires','new_patents']) {
            this.editingPerformance[k] = Number(this.editingPerformance[k]) || 0;
        }
        const payload = {
            id: this.editingPerformance.id || '',
            application_id: this.editingPerformance.application_id || app?.id || this.application_id,
            program_id: this.editingPerformance.program_id || '',
            company_id: this.editingPerformance.company_id || '',
            report_period: this.editingPerformance.report_period || '',
            revenue: this.editingPerformance.revenue || 0,
            investment_raised: this.editingPerformance.investment_raised || 0,
            new_hires: this.editingPerformance.new_hires || 0,
            new_patents: this.editingPerformance.new_patents || 0,
            awards: this.editingPerformance.awards || '',
            narrative: this.editingPerformance.narrative || '',
            status: this.editingPerformance.status || 'draft'
        };
        const r = await wiz.call('save_performance', { data: JSON.stringify(payload) });
        if (r.code !== 200) return this.service.alert.show({ title: '저장 실패', message: r.data?.message || '성과를 저장하지 못했습니다.', action: '확인' });
        this.editingPerformance = null;
        await this.loadTab();
    }

    public async deletePerformance(item: any) {
        if (!item?.id || !confirm('성과 보고를 삭제하시겠습니까?')) return;
        const r = await wiz.call('delete_performance', { performance_id: item.id });
        if (r.code !== 200) return this.service.alert.show({ title: '삭제 실패', message: r.data?.message || '성과를 삭제하지 못했습니다.', action: '확인' });
        await this.loadTab();
    }

    private _buildFormAnswers() {
        this.formAnswers = [];
        this.formAnswerGroups = [];
        const apps = this.applicationHistory?.length ? this.applicationHistory : (this.application ? [this.application] : []);
        for (const app of apps) {
            const answers = this._answersForApplication(app);
            if (answers.length === 0) continue;
            const group = {
                application: app,
                title: this.historyTitle(app),
                answers,
                attachments: app.attachments || []
            };
            this.formAnswerGroups.push(group);
            if (app.id === this.application?.id) this.formAnswers = answers;
        }
        if (this.formAnswers.length === 0 && this.formAnswerGroups.length > 0) {
            this.formAnswers = this.formAnswerGroups[0].answers;
        }
    }

    private _answersForApplication(app: any): any[] {
        const extra = this._jsonObject(app?.extra);
        const fd = this._jsonObject(extra?.form_data);
        if (!fd) return [];
        const fields = this._formFields(app?.announcement);
        const answers: any[] = [];
        if (fields.length === 0) {
            for (const key of Object.keys(fd)) {
                answers.push({ id: key, label: key, type: 'text', value: this._answerText(fd[key]) });
            }
            return answers;
        }
        for (const f of fields) {
            if (f.type === 'section' || f.type === 'file') continue;
            let v = fd[f.id];
            answers.push({ id: f.id, label: f.label, type: f.type, value: this._answerText(v) });
        }
        return answers;
    }

    private _jsonObject(value: any): any {
        if (!value) return null;
        if (typeof value === 'string') {
            try { return JSON.parse(value); } catch (e) { return null; }
        }
        return value;
    }

    private _formFields(announcement: any): any[] {
        const schema = this._jsonObject(announcement?.form_schema);
        return Array.isArray(schema?.fields) ? schema.fields : [];
    }

    private _answerText(value: any): string {
        if (Array.isArray(value)) return value.join(', ');
        if (value === undefined || value === null || value === '') return '';
        if (typeof value === 'object') return JSON.stringify(value, null, 2);
        return String(value);
    }

    public goCompany() {
        if (this.company && this.company.id) {
            this.service.href(`/admin/invest/company/${this.company.id}/info`);
        }
    }

    public async relink() {
        if (!confirm('기업 매칭을 다시 시도하시겠습니까?')) return;
        const r = await wiz.call('link_company', { application_id: this.application_id });
        if (r.code != 200) {
            this.service.alert.show({ title: '실패', message: r.data?.message || '오류', action: '확인' });
            return;
        }
        await this.reload();
    }

    public async resendEmail() {
        if (!confirm('신청자(' + (this.application?.ceo_email || '') + ')에게 접수확인 메일을 재발송할까요?')) return;
        await this.service.loading.show();
        const r = await wiz.call('resend_email', { application_id: this.application_id });
        await this.service.loading.hide();
        if (r.code != 200) {
            this.service.alert.show({ title: '실패', message: r.data?.message || '메일 발송에 실패했습니다.', action: '확인' });
            return;
        }
        this.service.alert.show({ title: '발송 완료', message: '접수확인 메일이 재발송되었습니다.', action: '확인' });
    }

    public investmentAmount(inv: any): number {
        return Number(inv?.investment_amount ?? inv?.amount) || 0;
    }

    public totalInvestment(): number {
        return this.investments.reduce((s, x) => s + this.investmentAmount(x), 0);
    }

    private normalizeInvestment(inv: any): any {
        const row = { ...(inv || {}) };
        const dateValue = row.investment_date || row.invest_date || row.founded_date || '';
        row.investment_date = dateValue ? String(dateValue).slice(0, 10) : '';
        row.investment_type = row.investment_type || row.invest_type || '';
        row.investment_amount = Number(row.investment_amount ?? row.amount) || 0;
        row.invested_shares = Number(row.invested_shares) || 0;
        row.price_per_share = Number(row.price_per_share) || 0;
        row.investment_valuation = Number(row.investment_valuation) || 0;
        row.share_ratio = Number(row.share_ratio) || 0;
        return row;
    }
}

export default PortalLpsysadminSupportApplicationItemComponent;